import getAnalyticsObjectAU from 'utils/analytics/getAnalyticsObjectAU';
import { track } from 'actions/analytics';
import { GTM_EVENT_NAMES } from 'consts/gtmEvents';
import { STEP_BANK_STATEMENT } from 'consts/loan/AU/steps';

export const trackProvisoStatus = (provisoStatus) => track(GTM_EVENT_NAMES.PROVISO_STATUS, {
  analyticsAU: (storeState) => getAnalyticsObjectAU(STEP_BANK_STATEMENT.type, storeState, {
    provisoStatus,
  }),
});

export const trackProvisoIframeNavigation = ({ navigationCount, elapsedTime }) => track(
  GTM_EVENT_NAMES.PROVISO_IFRAME_NAVIGATION,
  {
    analyticsAU: (storeState) => ({
      ...getAnalyticsObjectAU(STEP_BANK_STATEMENT.type, storeState),
      event: GTM_EVENT_NAMES.PROVISO_IFRAME_NAVIGATION,
      proviso_navigation_count: `${navigationCount}`,
      proviso_navigation_time: `${elapsedTime}`,
    }),
  }
);
